function OnsiteConfig($q, $rootScope, onsiteSettingsService, twilioService) {
    return {
        redirect: 'E',
        scope: {
            logId: "="
        },
		template: require('./onsite-config.html'),

        link: function (scope) {
            
            function getCleanPhoneNumber() {
                if (!scope.settings || typeof scope.settings.phoneNumber !== 'string') return null;
                return scope.settings.phoneNumber.replace(/\+1/, "");
            }

            function checkAllowPurchase(settings) {
                settings.allowPurchase = (settings.updated) ? moment(settings.updated)
                        .isAfter(moment()
                            .subtract(30, 'days')
                            .startOf('day')) :
                    true;
                return settings;
            }

            function finalize(settings) {
                scope.cancelEdit();
                scope.settings = settings;
            }

            function saveSettings() {
                var deferred = $q.defer();
                const cleanNumber = getCleanPhoneNumber();
                if (typeof cleanNumber === 'string')
                    scope.settings.phoneNumber = cleanNumber;

                if($rootScope.selectedLog.role === 'ADMIN') {
                    if (angular.isUndefined(scope.settings.id)) {
                        onsiteSettingsService.addSettings(scope.settings).$promise.then(function (settings) {
                            deferred.resolve(checkAllowPurchase(settings));
                        });
                    } else {
                        onsiteSettingsService.updateSettings(scope.settings).$promise.then(function (settings) {
                            deferred.resolve(checkAllowPurchase(settings));
                        });
                    }
                }else{
                    deferred.resolve(scope.settings);
                }

                return deferred.promise;
            }

            function saveConfigs() {
                var deferred = $q.defer();

                if(angular.isUndefined(scope.configs.OnsiteSounds.id)) {
                    //add a new config here.
                    onsiteSettingsService.addSoundConfig({
                        key: 'OnsiteSounds',
                        value: scope.configs.OnsiteSounds.value,
                        log: $rootScope.selectedLog._links.self.href,
                        dataTypeId: 1
                    }).then(function(newConfig){
                        scope.configs.OnsiteSounds = newConfig;
                        deferred.resolve(newConfig);
                    });
                } else {
                    scope.configs.OnsiteSounds.obj.value = scope.configs.OnsiteSounds.value;
                    onsiteSettingsService.updateSoundConfig(scope.configs.OnsiteSounds.obj).then(function(updatedConfig){
                        scope.configs.OnsiteSounds = updatedConfig;
                        deferred.resolve(updatedConfig);
                    });
                }
                return deferred.promise;
            }

            //declare scope methods.
            scope.onAreaCodeChanged = function () {
                if (scope.search.areaCode.length === 3) {
                    scope.searching = true;
                    scope.search.availableNumbers = twilioService.searchByAreaCode(scope.search.areaCode)
                        .then(function (availableNumbers) {
                            scope.search.message = (availableNumbers.length < 1) ? "No numbers found for that area code" : "";
                            scope.search.availableNumbers = availableNumbers;
                            scope.searching = false;
                        });
                } else {
                    scope.search.availableNumbers = [];
                }
            };

            scope.onSelectedNumberChanged = function () {
                scope.settings.phoneNumber = scope.search.selectedNumber.endpoint;
            };

            scope.enableEdit = function () {
                scope.edit = true;
            };

            scope.cancelEdit = function () {
                $("#purchase-confirmation-modal").modal('hide');
                scope.search.selectedNumber = "";
                scope.search.availableNumbers = [];
                scope.search.selectedAreaCode = "";
                scope.edit = false;
                onsiteSettingsService.getOnSiteSettingsByLogId(scope.logId).then(function (settings) {
                    scope.settings = checkAllowPurchase(settings);
                });
            };

            scope.validateNumber = function () {
                if(scope.originalNumber !== scope.settings.phoneNumber) {
                    if (scope.search.numberType === 'Existing') {
                        twilioService.verifyNumber(scope.settings.phoneNumber, scope.settings.logId).then(function (verified) {
                            if (verified.validNumber) {
                                $("#purchase-confirmation-modal").modal('show');
                            } else {
                                //show an error.
                                scope.errorMessage = "The number you entered is not a registered Onsite Phone Number. Please check your entry and try again.";
                                setTimeout(function () {
                                    scope.errorMessage = null;
                                }, 5000);
                            }
                        });
                    } else {
                        $("#purchase-confirmation-modal").modal('show');
                    }
                }else{
                    saveConfigs().then(function(configs){
                        scope.configs[configs.key].id = configs.id;
                        saveSettings().then(finalize);
                    });
                }
            };

            scope.saveNumber = function () {
                if(scope.selectedLog.role === 'ADMIN') {
                    if (scope.search.numberType === "New") {
                        twilioService.purchaseNumber(scope.settings.phoneNumber, scope.settings.logId).$promise
                            .then(saveSettings)
                            .then(complete);
                    } else {
                        saveSettings().then(complete);
                    }
                }
                else {
                    complete();
                }
                
                function complete() {
                    return saveConfigs().then(function(configs){
                        scope.configs[configs.key].id = configs.id;
                        finalize(scope.settings);
                    });
                }
            };



            (function () {
                scope.search = {
                    areaCode: "",
                    numberType: "New",
                    selectedNumber: "",
                    availableNumbers: []
                };
                scope.edit = false;
                scope.originalNumber = null;
                scope.selectedLog = $rootScope.selectedLog;

                onsiteSettingsService.getOnSiteSettingsByLogId(scope.logId).then(function (settings) {
                    settings.levelOneWarning = settings.levelOneWarning || 8;
                    settings.levelTwoWarning = settings.levelTwoWarning || 24;
                    scope.search.numberType = settings.phoneNumber ? "Existing" : "New";
                    scope.originalNumber = settings.phoneNumber;
                    scope.settings = checkAllowPurchase(settings);
                });

                onsiteSettingsService.getLogUserConfigsByLogId(scope.logId).then(function(configs) {
                    scope.configs = configs;
                });
            })();
        }
    }
}

angular.module('onsite').directive('onsiteConfig', ["$q", "$rootScope", 'onsiteSettingsService', 'twilioService', OnsiteConfig]);
